import { render } from "./SeaMap.vue?vue&type=template&id=484468b3&scoped=true&ts=true"
import script from "./SeaMap.vue?vue&type=script&lang=ts"
export * from "./SeaMap.vue?vue&type=script&lang=ts"

import "./SeaMap.vue?vue&type=style&index=0&id=484468b3&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484468b3"]])

export default __exports__